import { createFileRoute } from "@tanstack/react-router";
import { IndiaDominationScore } from "@/components/admin/IndiaDominationScore";
import { IndiaCommunityFeed } from "@/components/growth/IndiaCommunityFeed";
import { IndiaShareCenter } from "@/components/growth/IndiaShareCenter";

export const Route = createFileRoute("/admin/india-domination")({
  head: () => ({
    meta: [
      { title: "India Domination Score — VerseSport Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: IndiaDominationPage,
});

function IndiaDominationPage() {
  return (
    <main className="mx-auto max-w-3xl space-y-3 px-3 py-4">
      <header>
        <h1 className="text-xl font-black">🇮🇳 India Command Center</h1>
        <p className="text-[12px] text-muted-foreground">
          Executive panel for India — growth, acquisition, virality, influencers,
          community, retention, predictions, nation impact and conversion.
        </p>
      </header>
      <IndiaDominationScore />
      <IndiaShareCenter />
      <IndiaCommunityFeed />
    </main>
  );
}